import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const constRouters = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login')
    },
    {
        path: '/reset',
        name: 'Reset',
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'pass',
                name: 'Pass',
                component: () => import('@/views/ResetPass')
            }
        ]
    }
]
export const asyncRouters = [
    /* ==============================首页============================== */
    {
        path: '/',
        name: 'Home',
        meta: { icon: 'home_logo', title: '首页', role: 'Index_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'home',
                name: '首页',
                component: () => import('@/views/Home/index')
            }
        ]
    },
    /* ==============================发车计划============================== */
    {
        path: '/dispatchCar',
        name: 'DispatchCar',
        meta: { icon: 'fache', title: '发车计划', role: 'Plan_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'list',
                name: '发车计划',
                component: () => import('@/views/dispatchCar/List')
            }
        ]
    },
    /* ==============================运单管理============================== */
    {
        path: '/OrderRun',
        name: 'OrderRun',
        meta: { icon: 'yundan', title: '运单管理', role: 'OrderRun_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'index',
                name: '我的运单',
                meta: { title: '我的运单' },
                component: () => import('@/views/OrderRun')
            },
            {
                path: 'Transit',
                name: '运输中运单',
                meta: { title: '运输中运单' },
                component: () => import('@/views/OrderRun/Transit')
            },
            {
                path: 'Arrive',
                name: '到达运单',
                meta: { title: '到达运单' },
                component: () => import('@/views/OrderRun/Arrive')
            },
            {
                path: 'Cancel',
                name: '取消派车单',
                meta: { title: '取消派车单' },
                component: () => import('@/views/OrderRun/Cancel')
            },
            {
                path: 'Overtime',
                name: '超时运单',
                meta: { title: '超时运单' },
                component: () => import('@/views/OrderRun/Overtime')
            },
        ]
    },
    /* ==============================应收运单============================== */
    {
        path: '/OrderReceivable',
        name: 'OrderReceivable',
        meta: { icon: 'orders_logo', title: '应收管理', role: 'OrderReceivable_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'list',
                name: '应收管理',
                component: () => import('@/views/OrderReceivable')
            }
        ]
    },
    /* ==============================车队账本============================== */
    {
        path: '/MotorBook',
        name: 'MotorBook',
        meta: { icon: 'zhangben', title: '车队管理', role: 'Motor_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'list',
                name: '车辆列表',
                meta: { title: '车辆列表' },
                component: () => import('@/views/MotorBook')
            },
            {
                path: 'incidental',
                name: '杂费明细',
                meta: { title: '杂费明细' },
                component: () => import('@/views/MotorBook/incidental')
            },
            {
                path: 'empmanage',
                name: '员工管理',
                meta: { title: '员工管理' },
                component: () => import('@/views/MotorBook/empmanege')
            }
        ]
    },
    /* ==============================油卡充值============================== */
    {
        path: '/OilCard',
        name: 'OilCard',
        meta: { icon: 'oilcard_logo', title: '油卡充值', role: 'OilCard_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'list',
                name: '油卡充值',
                component: () => import('@/views/OilCard')
            }
        ]
    },
    /* ==============================财务管理============================== */
    {
        path: '/Finance',
        name: 'Finance',
        meta: { icon: 'caiwu', title: '财务管理', role: 'Finance_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'list',
                name: '运单审核',
                meta: { title: '运单审核' },
                component: () => import('@/views/Finance')
            },
            {
                path: 'incidental',
                name: '杂费审核',
                meta: { title: '杂费审核' },
                component: () => import('@/views/Finance/incidental')
            },
            {
                path: 'payment',
                name: '财务打款',
                meta: { title: '财务打款' },
                component: () => import('@/views/Finance/payment')
            },
            {
                path: 'ysaudit',
                name: '应收审核',
                meta: { title: '应收审核' },
                component: () => import('@/views/Finance/ysaudit')
            },
            {
                path: 'report',
                name: '财务报表',
                meta: { title: '财务报表' },
                component: () => import('@/views/Finance/report')
            },
            {
                path: 'empWage',
                name: '员工工资',
                meta: { title: '员工工资' },
                component: () => import('@/views/Finance/empWage')
            },
        ]
    },
    /* ==============================资源管理============================== */
    {
        path: '/resources',
        name: 'Resources',
        meta: { icon: 'source_logo', title: '资源管理', role: 'Source_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'carrier',
                name: '承运商管理',
                meta: { title: '承运商管理' },
                component: () => import('@/views/Resources/Carrier')
            },
            {
                path: 'driver',
                name: '司机管理',
                meta: { title: '司机管理' },
                component: () => import('@/views/Resources/Driver')
            },
            {
                path: 'car',
                name: '车辆管理',
                meta: { title: '车辆管理' },
                component: () => import('@/views/Resources/Car')
            },
            {
                path: 'black',
                name: '黑名单管理',
                meta: { title: '黑名单管理' },
                component: () => import('@/views/Resources/Black')
            }
        ]
    },
    /* ==============================基础管理============================== */
    {
        path: '/basics',
        name: 'Basics',
        meta: { icon: 'source_logo', title: '基础管理', role: 'Basics_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'list',
                name: '基础管理',
                component: () => import('@/views/Basics/List')
            }
        ]
    },
    /* ==============================基础管理============================== */
    {
        path: '/System',
        name: 'System',
        meta: { icon: 'system_logo', title: '系统管理', role: 'System_Look' },
        component: () => import('@/views/Layout'),
        children: [
            {
                path: 'admin',
                name: '账号管理',
                meta: { title: '账号管理' },
                component: () => import('@/views/System/Admin')
            },
            {
                path: 'role',
                name: '角色管理',
                meta: { title: '角色管理' },
                component: () => import('@/views/System/Role')
            },
            {
                path: 'announce',
                name: '公告信息',
                meta: { title: '公告信息' },
                component: () => import('@/views/System/Announce')
            },
            {
                path: 'carousel',
                name: '轮播图',
                meta: { title: '轮播图' },
                component: () => import('@/views/System/Carousel')
            },
            {
                path: 'tc-cooperated',
                name: '运力合作',
                meta: { title: '运力合作' },
                component: () => import('@/views/System/TcCooperated')
            },
            {
                path: 'feedback',
                name: '意见反馈',
                meta: { title: '意见反馈' },
                component: () => import('@/views/System/Feedback')
            },
            {
                path: 'reporting',
                name: '举报中心',
                meta: { title: '举报中心' },
                component: () => import('@/views/System/Reporting')
            },
        ]
    }
]



export default new VueRouter({
    routes: constRouters
});
